import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import HighwayUnpaidEditConfirmBottomSheet from '@di-shared/features/public-service/highway-unpaid/HighwayUnpaidEditConfirmBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

function HighwayUnpaidEditConfirmBottomSheetPage() {
  const {beforeLicensePlate, afterLicensePlate} = (window as any).data as {
    beforeLicensePlate: string;
    afterLicensePlate: string;
  };

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <HighwayUnpaidEditConfirmBottomSheet
        beforeLicensePlate={beforeLicensePlate}
        afterLicensePlate={afterLicensePlate}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default HighwayUnpaidEditConfirmBottomSheetPage;
